import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import s from './index.module.scss';

export const AdvancedPricing = () => {
  const { t } = useTranslation('plans-v5');
  return (
    <div className={s.wrapper}>
      <div className={s.inner}>
        <div className={classnames(s.table_standard, 'text_l')}>
          <div className={s.row}>
            <div className={s.col}>{t('pricing.risk_factor')}</div>
            <div className={s.col}>{t('pricing.low')}</div>
            <div className={s.col}>{t('pricing.medium')}</div>
            <div className={s.col}>{t('pricing.high')}</div>
          </div>
          <div className={s.row}>
            <div className={s.col}>{t('pricing.monthly_repayment')}</div>
            <div className={s.col}>8%</div>
            <div className={s.col}>6%</div>
            <div className={s.col}>8%</div>
          </div>
          <div className={s.row}>
            <div className={s.col}>
              {t('pricing.effective_irr')} <div>{t('pricing.for_reference_use')}</div>
            </div>
            <div className={s.col}>15.9%</div>
            <div className={s.col}>18.4%</div>
            <div className={s.col}>22%</div>
          </div>
          <div className={s.row}>
            <div className={s.col}>
              {t('pricing.flat_fee')} <div>{t('pricing.for_each_6_months')}</div>
            </div>
            <div className={s.col}>6%</div>
            <div className={s.col}>7.25%</div>
            <div className={s.col}>8%</div>
          </div>
        </div>
      </div>
    </div>
  );
};
